import { formatDate } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DownloaderService } from '../../shared/download/downloader.service';
import { JsonHttpService } from '../../shared/http/json-http.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TestToolExportService {
  private http = inject(JsonHttpService);
  private downloaderService = inject(DownloaderService);

  async exportCompareRules(ids: number[]): Promise<void> {
    const filename = `CompareRulesExport_${formatDate(new Date(), 'yyyyMMdd_HHmmss', 'en')}`;
    const options = { params: new HttpParams().set('filename', filename) };
    const token = await firstValueFrom(this.http.postTyped<string>('/api/test-tool/compare-plugin/export', ids, options));
    return this.downloaderService.downloadFile(token);
  }
}
